import { createAction } from '@wix/communities-blog-client-common';

export const HEADER_SEARCH_OPENED = 'header/SEARCH_OPENED';
export const HEADER_SEARCH_CLOSED = 'header/SEARCH_CLOSED';

export const headerSearchOpened = createAction(HEADER_SEARCH_OPENED);
export const headerSearchClosed = createAction(HEADER_SEARCH_CLOSED);
